// extracted by mini-css-extract-plugin
module.exports = {"scriptForm":"AltaPayScriptOption_scriptForm__TW6U3","scriptFrame":"AltaPayScriptOption_scriptFrame__FOuzz","scriptLoader":"AltaPayScriptOption_scriptLoader__4p2Vd"};